import type { SVGProps } from 'react';
const SvgCellWifi = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#cell_wifi_svg__a)">
      <path
        fill="currentColor"
        d="M18 9.98 6 22h16V5.97l-4 4.01ZM20 20h-2v-7.22l2-2V20ZM5.22 7.22 3.93 5.93c3.9-3.91 10.24-3.91 14.15 0l-1.29 1.29c-3.19-3.19-8.38-3.19-11.57 0Zm7.71 3.85L11 13l-1.93-1.93a2.74 2.74 0 0 1 3.86 0Zm1.29-1.28c-1.78-1.77-4.66-1.77-6.43 0L6.5 8.5a6.374 6.374 0 0 1 9 0l-1.28 1.29Z"
      />
    </g>
    <defs>
      <clipPath id="cell_wifi_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCellWifi;
